
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './../models/config/appConfig';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class AppConfigService {

  public appConfig: AppConfig;
  public appConfigNull: AppConfig = null;
  private appConfigSubject: BehaviorSubject<AppConfig> = new BehaviorSubject<AppConfig>(null);

  constructor(private http: HttpClient) { }

  public loadEnvironment() {
    // Only want to do this once - if root page is revisited, it calls this again.
    if (this.appConfig === null || this.appConfig === undefined) {
      console.log('Loading app.config.json');

      return this.http.get('./assets/app.config.json').pipe(
        map((data: AppConfig) => data))
        .toPromise<AppConfig>();
    }

    return Promise.resolve(this.appConfigNull);
  }


  public setEnvSpecific(ac: AppConfig) {
    // This has already been set so bail out.
    if (ac === null || ac === undefined) {
      return;
    }

    this.appConfig = ac;
    console.log(this.appConfig);

    if (this.appConfigSubject) {
      this.appConfigSubject.next(this.appConfig);
    }
  }

  /*
    Call this if you want to know when EnvSpecific is set.
  */
  public subscribe(caller: any, callback: (caller: any, ac: AppConfig) => void) {
    this.appConfigSubject
      .subscribe((ac) => {
        if (ac === null) {
          return;
        }
        callback(caller, ac);
      });
  }

}
